export { default } from "./image";
